import React from 'react';
import { Modal, message, Button } from 'antd';
import classnames from 'classnames';
import { ReactComponent as CloseIcon } from '@/images/icons/close_modal.svg';
import { apiHolder as api, apis } from 'api';
import styles from './index.module.scss';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const HiddenTxtModal = props => {
    const { visible: commentVisible, setVisible: setCommentVisible, handleCommentOk, hiddenTxt, editorInstance } = props;
    return (React.createElement(Modal, { centered: true, title: "\u68C0\u6D4B\u5230\u90AE\u4EF6\u6B63\u6587\u4E2D\u5B58\u5728\u90E8\u5206\u88AB\u9690\u85CF\u7684\u5185\u5BB9\uFF0C\u5982\u9700\u4FEE\u6539\u8BF7\u91CD\u65B0\u7F16\u8F91\u90AE\u4EF6\u5185\u5BB9\u3002\u9690\u85CF\u5185\u5BB9\u5982\u4E0B", width: 480, className: styles.hiddenTxtModal, visible: commentVisible, onCancel: () => {
            setCommentVisible(false);
        }, closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }), destroyOnClose: true, footer: [
            React.createElement(Button, { key: "delete", onClick: e => {
                    e.stopPropagation();
                    if (editorInstance) {
                        const eleList = editorInstance.getDoc().querySelectorAll('.hidden-ele-write-mail') || [];
                        for (let i = 0; i < eleList.length; i++) {
                            eleList[i].remove();
                        }
                        editorInstance.focus();
                    }
                    message.success('删除隐藏内容成功');
                    setCommentVisible(false);
                }, className: classnames('local-import-btn', styles.deleteBtn) }, "\u5220\u9664\u9690\u85CF\u5185\u5BB9"),
            React.createElement(Button, { key: "cancel", onClick: e => {
                    e.stopPropagation();
                    setCommentVisible(false);
                }, className: "local-import-btn" }, "\u91CD\u65B0\u7F16\u8F91"),
            React.createElement(Button, { key: "confirm", type: "primary", onClick: e => {
                    e.stopPropagation();
                    setCommentVisible(false);
                    handleCommentOk();
                }, className: "local-import-btn" }, "\u7EE7\u7EED\u53D1\u9001"),
        ] },
        React.createElement("div", null, hiddenTxt)));
};
export default HiddenTxtModal;
